import { createSlice } from "@reduxjs/toolkit";
const initialValue = {
  menus: [],
  loading: false,
};

const MenuSlice = createSlice({
  name: "allMenus",
  initialState: initialValue,
  reducers: {
    setMenus: (state, action) => {
      return {
        ...state,
        menus: [...action.payload],
      };
    },
    toggleLoading : (state, action) => {
      return {
        ...state,
        loading: action.payload
      }
    }
  },
});

const { reducer } = MenuSlice;
export default reducer;
export const { setMenus, toggleLoading } = MenuSlice.actions;
